export const ActionTypes = {
    LOADING: "DELETE_MISSION_STATEMENT_LOADING",
    ERROR: "DELETE_MISSION_STATEMENT_ERROR",
    SUCCESS: "DELETE_MISSION_STATEMENT_SUCCESS",
};
